// extracted by mini-css-extract-plugin
export default {"main":"Sbw0UcfJk1FbmQ6HsUpK"};